import React, { FunctionComponent, useMemo } from 'react';

import BlockContent from '@sanity/block-content-to-react';
import articleHighlightRenderer from './renderers/articleHighlightRenderer';
import articleImageRenderer from './renderers/articleImageRenderer';
import articleInfoRenderer from './renderers/articleInfoRenderer';
import articleQuoteRenderer from './renderers/articleQuoteRenderer';
import articleVideoRenderer from './renderers/articleVideoRenderer';
import blockRenderer from './renderers/blockRenderer';
import centerRenderer from './renderers/centerRenderer';
import internalLinkRenderer from './renderers/internalLinkRenderer';
import linkRenderer from './renderers/linkRenderer';
import listItemRenderer from './renderers/listItemRenderer';
import listRenderer from './renderers/listRenderer';
import strongRenderer from './renderers/strongRenderer';

export type BlockRendererProps = {
  blocks?: any;
};

const BlockRenderer: FunctionComponent<BlockRendererProps> = (props) => {
  const { blocks } = props;

  const serializers = useMemo(() => {
    return {
      types: {
        block: blockRenderer,
        article_image: articleImageRenderer,
        article_quote: articleQuoteRenderer,
        article_info: articleInfoRenderer,
        article_highlight: articleHighlightRenderer,
        article_embedded_video: articleVideoRenderer,
      },
      list: listRenderer,
      listItem: listItemRenderer,
      hardBreak: false,
      marks: {
        strong: strongRenderer,
        link: linkRenderer,
        center: centerRenderer,
        internal_link: internalLinkRenderer,
      },
    };
  }, []);

  if (!blocks) {
    return null;
  }
  return <BlockContent blocks={blocks} serializers={serializers} />;
};

export default BlockRenderer;
